const tg = window.Telegram.WebApp;

export default tg;
